var _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "#F8F8FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    stroke: "#EBEBEB",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3153_15726",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 21,
    height: 20
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3153_15726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0834 23.0003L12.9167 21.8337L20.9167 13.8337H13.7501V12.167H23.7501V22.167H22.0834V15.0003L14.0834 23.0003Z",
    fill: "#22222F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateIcon);
export default __webpack_public_path__ + "static/media/navigateIcon.9cc8608b0c405bbcb634378425f05184.svg";
export { ForwardRef as ReactComponent };